import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'

import type { ListEntriesOptions } from '../types'
import { listEntries } from '../utils/persistence'

export function useBrowsingHistory() {
  const locale = useI18nLocale()

  function fetch(options?: ListEntriesOptions) {
    return listEntries(locale, Date.now(), options)
  }

  return { fetch }
}
